import { Component } from 'react';
import BaseChart from 'legacy/javascripts/components/base_chart.es6';

class CategoriesHorizontalBarChart extends Component {
  drawLabelsNextToBars(animation, datasets) {
    let chartInstance = animation.chart;
    let ctx = chartInstance.ctx;
    const fontFamily = 'Nunito';

    ctx.font = Chart.helpers.fontString(
      Chart.defaults.global.defaultFontSize,
      Chart.defaults.global.defaultFontStyle,
      Chart.defaults.global.defaultFontFamily,
    );

    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';

    datasets.forEach((dataset, i) => {
      const meta = chartInstance.controller.getDatasetMeta(i);
      meta.data.forEach((bar, index) => {
        const data = dataset.data[index];
        ctx.font = `10pt ${fontFamily}`;
        ctx.fillStyle = '#000000';
        const label = `${data}%`;
        ctx.fillText(label, bar._model.x + 20, bar._model.y + 8);
      });
    });
  }

  render() {
    const options = {
      legend: { display: false },
      tooltips: {
        enabled: false,
      },
      layout: {
        padding: {
          left: 15,
          right: 0,
          top: 0,
          bottom: 0,
        },
      },
      scales: {
        xAxes: [
          {
            ticks: {
              suggestedMax: this.props.chartMax,
              beginAtZero: true,
              display: false,
            },
            gridLines: {
              display: false,
              drawBorder: false,
            },
          },
        ],
        yAxes: [
          {
            gridLines: {
              display: false,
              drawBorder: false,
            },
          },
        ],
      },
      animation: {
        duration: 1,
        onComplete: animation => {
          this.drawLabelsNextToBars(animation, this.props.datasets);
        },
      },
    };
    return (
      <BaseChart
        id={this.props.id}
        type={this.props.type}
        labels={this.props.columns}
        datasets={this.props.datasets}
        options={options}
      />
    );
  }
}

export default CategoriesHorizontalBarChart;
/* eslint-enable no-undef */
/* eslint-enable react/no-deprecated */
